module.exports = __webpack_public_path__ + "static/media/socialimg.ef59490a.png";